/* Copyright Information: Created by BuyGroup */
import React, { Component } from "react";
import { Row, Col, Card, Spinner, CardBody, Button, Badge } from "reactstrap";
import Breadcrumbs from "../components/common/breadcrumb";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { adminList, addAdmin } from "../services/AdminServices";
import AddAdmin from "./CreateAdmin";
import Moment from "react-moment";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
toast.configure();

export default class AdminsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      admins: [],
      showModal: false,
      isDisableAdd: false,
      initialValues: {
        name: "",
        email: "",
        role: "ADMIN", // or SUB_ADMIN
        password: "",
      },
    };
  }

  componentDidMount() {
    this.fetchAdmins();
  }

  fetchAdmins = () => {
    this.setState({ isLoading: true });
    adminList()
      .then((response) => {
        console.log(response.data);
        this.setState({ admins: response.data || [], isLoading: false });
      })
      .catch((error) => {
        toast.error(error?.data?.message || "Failed to load admins", {
          autoClose: 3000,
          hideProgressBar: true,
        });
        this.setState({ isLoading: false });
      });
  };

  openModal = () => this.setState({ showModal: true });
  closeModal = () => this.setState({ showModal: false });

  onAddAdmin = (formData) => {
    this.setState({ isDisableAdd: true });
    addAdmin(formData)
      .then((response) => {
        toast.success(response?.message || "Admin created", {
          autoClose: 3000,
          hideProgressBar: true,
        });
        this.setState({ showModal: false, isDisableAdd: false });
        this.fetchAdmins();
      })
      .catch((error) => {
        toast.error(error?.data?.message || "Failed to create", {
          autoClose: 3000,
          hideProgressBar: true,
        });
        this.setState({ isDisableAdd: false });
      });
  };

  roleFormatter = (cell) => {
    const color = cell === "ADMIN" ? "primary" : "secondary";
    return <Badge color={color}>{cell}</Badge>;
  };

  dateFormatter = (cell) => <Moment format="MM/DD/YYYY">{cell}</Moment>;

  render() {
    const { SearchBar } = Search;

    const columns = [
      { dataField: "id", text: "ID", sort: true },
      {
        dataField: "name",
        text: "Name",
        formatter: (cell, row) => (
          <span>{row.name}</span>
        ),
        sort: true,
      },
      { dataField: "email", text: "Email" },
      { dataField: "role", text: "Role", formatter: this.roleFormatter },
      { dataField: "created_at", text: "Created", formatter: this.dateFormatter, sort: true },
    ];

    return (
      <>
        <Breadcrumbs title="Admins" parent="" subtitle="Admins" />
        <div className="container-fluid">
          <Row className="row">
            <Col md="12">
              <Card className="card-box">
                <div className="card-header">
                  <div className="d-flex align-items-center flex-wrap justify-content-between">
                    <h5>Admins & Sub-Admins</h5>
                    <Button type="button" color="secondary" onClick={this.openModal}>
                      <i className="fa fa-plus mr-2"></i>
                      Create Admin
                    </Button>
                  </div>
                </div>
                <CardBody>
                  <ToolkitProvider keyField="AdminsListTable" data={this.state.admins} columns={columns} search>
                    {(props) => (
                      <>
                        {this.state.isLoading ? (
                          <div className="custom-loader">
                            <Spinner animation="border" />
                          </div>
                        ) : (
                          <>
                            <Row className="table_SearchBar select_dropdown">
                              <Col lg={4} className="filter-container-col">
                                <SearchBar {...props.searchProps} className="custome-search-table manage-width" placeholder="Search Admin" />
                              </Col>
                            </Row>
                            <BootstrapTable
                              {...props.baseProps}
                              keyField="id"
                              striped
                              hover
                              condensed
                              bordered={false}
                              data={this.state.admins}
                              columns={columns}
                              noDataIndication={"No admins available"}
                              pagination={paginationFactory({
                                sizePerPage: 25,
                                showTotal: true,
                                hideSizePerPage: true,
                              })}
                              rowClasses="row-hover"
                            />
                          </>
                        )}
                      </>
                    )}
                  </ToolkitProvider>
                </CardBody>
              </Card>
              {this.state.showModal && (
                <AddAdmin
                  showModal={this.state.showModal}
                  onClose={this.closeModal}
                  initialValues={this.state.initialValues}
                  onSubmit={this.onAddAdmin}
                  isDisableAdd={this.state.isDisableAdd}
                />
              )}
            </Col>
          </Row>
        </div>
      </>
    );
  }
}

/* Copyright Information: Created by BuyGroup */


